import React, { useContext, useEffect } from "react";

import { SettingsContext, UserContext } from '../contexts/index.jsx';

import { MyCommissions } from "./Dashboard/index.jsx";
import "./Dashboard/earnings-page.scss";

// /earnings — the signed-in user's OWN commissions in the active store, built to the
// approved "Earnings page preview" artifact (2026-10-28): "My Earnings" + who/where
// pill, the commissions card (tiles + monthly chart) and the deals list.
//
// Rewards and refer-a-friend are not part of this release (Alex, 2026-10-28) — their
// components still exist but are not mounted; the rework is parked on branch
// park/earnings-rewards-invite. Old /earnings/rewards links land here.

const Dashboard = ({ user }) => {
  const { notifications, seeNotification } = useContext(UserContext);
  const { settings } = useContext(SettingsContext);

  const name = [user?.first_name, user?.last_name].filter(Boolean).join(" ") || user?.full_name;
  const who = [name, settings?.name].filter(Boolean).join(" · ");

  useEffect(() => {
    seeNotification("dashboard");
  }, [notifications]);

  return (
    // `ft-earnings` FIRST is load-bearing: public/css/theme.css forces Calibri 14px
    // weight 100 onto every element except design-system (`ft-*`) subtrees, and that
    // rule outranks any class. No #dashboard id either — legacy theme.css styles
    // `#dashboard table …` (12px cells on a white ground), and an id beats classes.
    <main className="ft-earnings earn-page">
      <div className="earn-page__inner">
        <header className="earn-page__head">
          <h1 className="earn-page__title">My Earnings</h1>
          {who && <span className="earn-pill">{who}</span>}
        </header>

        <MyCommissions />
      </div>
    </main>
  );
};

export default Dashboard;
